// extracted by mini-css-extract-plugin
export default {"loginLeftBar":"LoginLeftBar_loginLeftBar__fWKzc","descText":"LoginLeftBar_descText__5pe-8","bottomText":"LoginLeftBar_bottomText__g-sFu"};